import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const loanSlice = createSlice({
    name: "loan",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,
        model: false,
        drawer: false,
        error_msg: null,
        listCount: 0,
        loanList: [],
        loanParams: {
            start_date: "",
            end_date: "",
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        rowdata: {},
        loanViewData: {},
        viewModel: false,
    },
    reducers: {
        clearloanData: (state, action) => {
            return {
                ...state,
                loading: false,
                loanList: [],
                rowdata: {},
            }
        },
        getloanList: (state, action) => {
            if (state.loanParams?.page == 1) {
                return {
                    ...state,
                    loading: true,
                    loanList: [],
                };
            } else {
                return {
                    ...state,
                    loading: true,
                };
            }
        },
        loanListSuccessful: (state, action) => {
            var response = action.payload;
            var list = [];
            if (state.loanParams?.page == 1) {
                list = response.results;
            } else {
                list = response.results;
            }
            var noofpages = Math.ceil(
                action.payload.count / state.loanParams?.page_size
            );
            return {
                ...state,
                loanList: list,
                listCount: action.payload.count,
                loading: false,
                loanParams: {
                    ...state.loanParams,
                    no_of_pages: noofpages,
                },
            };
        },
        SetloanParams: (state, action) => {
            return {
                ...state,
                loanParams: action.payload,
            };
        },

        getloanByID: (state) => {
            return {
                ...state,
                loading: true,
                rowdata: {},
            };
        },
        loanByIDSuccessful: (state, action) => {
            const response = action.payload.response;

            return {
                ...state,
                loading: false,
                rowdata: {
                    id: response.id,
                    amount: response.amount,
                    loantype: response.loantype,
                    loantype_name: response.loantype_name,
                    status: response.status,
                    loan_ref_no: response.loan_ref_no,
                    oodu_id: response.oodu_id,
                    createdon: response.createdon,
                    modifiedon: response.modifiedon,
                    createdby: response.createdby,
                    modifiedby: response.modifiedby,
                    employee_id: response.employee?.id,
                    employee_name: response.employee?.fullname,
                    employee_username: response.employee?.username,
                    employee_phone: response.employee?.phone,
                    employee_profilepicture: response.employee?.profilepicture,
                    employee_firm: response.employee?.firm?.flat() || [],
                },
                model: action.payload.type === "update",
                viewModel: action.payload.type === "view",
                loanViewData: response,

            };
        },

        loanAdd: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },
        isModelVisible: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    loanViewData: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                    loanViewData: {},
                };
            }
        },
        isViewModelVisible: (state, action) => {
            if (action.payload) {
                return {
                    ...state,
                    viewModel: action.payload,
                    loanViewData: {},
                };
            } else {
                return {
                    ...state,
                    viewModel: action.payload,
                };
            }
        },
        loanDelete: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        isDrawerVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    drawer: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    drawer: action.payload,
                };
            }
        },
        FilterInputChangeValue: (state, action) => {
            return {
                ...state,
                loanParams: {
                    ...state.loanParams,
                    [action.payload.key]: action.payload.value,
                },
            };
        },

        apiError: (state, action) => {
            return {
                ...state,
                loading: false,
                error_msg: action.payload,
            };
        },
    },
});
export const {
    getloanList,
    loanListSuccessful,
    SetloanParams,
    getloanByID,
    loanByIDSuccessful,
    loanAdd,
    loanDelete,
    InputChangeValue,
    isModelVisible,
    isDrawerVisible,
    FilterInputChangeValue,
    isViewModelVisible,
    clearloanData,
    apiError,
} = loanSlice.actions;

export default loanSlice.reducer;
